import { render } from "./easyCamera.vue?vue&type=template&id=0e7af2c0"
import script from "./easyCamera.vue?vue&type=script&lang=js"
export * from "./easyCamera.vue?vue&type=script&lang=js"

import "./easyCamera.vue?vue&type=style&index=0&id=0e7af2c0&lang=css"

import exportComponent from "C:\\Project\\VuePro\\DTP\\dtp_index\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__